import { createSlice } from "@reduxjs/toolkit";
import { createDynamicThunk } from "../../../../service/requestHandler.js";

const API_Prefix = "/report/api/v1/sbom";

// -------- POST --------
export const RequestsByApplicationSBOMAPI = createDynamicThunk(
  "post/RequestsByApplicationSBOMAPI",
  API_Prefix + "/getApplicationWiseRequestCount"
);

export const RequestStatusCISOSBOMAPI = createDynamicThunk(
  "post/RequestStatusCISOSBOMAPI",
  API_Prefix + "/getRequestByStatusCounts"
);

export const VulActionPlanCISOSBOMAPI = createDynamicThunk(
  "post/VulActionPlanCISOSBOMAPI",
  API_Prefix + "/getStatusCountByProjectNames"
);

export const CISOsbomTableListAPI = createDynamicThunk(
  "post/CISOsbomTableListAPI",
  API_Prefix + "/cisoFindings/list",
  ["pageNumber", "itemsPerPage"]
);

export const ApproveAPI = createDynamicThunk(
  "post/ApproveAPI",
  "",
  ["URL"]
);

// ---- State ----
const initialState = {
  RequestsByApplicationSBOMData: [],
  RequestsByApplicationSBOMDataLoading: false,

  RequestStatusCISOSBOMData: [],
  RequestStatusCISOSBOMDataLoading: false,

  VulActionPlanCISOSBOMData: [],
  VulActionPlanCISOSBOMDataLoading: false,

  CISOSBOMTableData: [],
  CISOSBOMTableDataLoading: false,

  CISOSBOMapproveData: [],
  CISOSBOMapproveDataLoading: false,
};

// ---- Case Reducer Helper ----
const addApiCases = (builder, thunk, stateKey, isDelete = false) => {
  builder
    .addCase(thunk.pending, (state) => {
      state[`${stateKey}Loading`] = true;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[`${stateKey}Loading`] = false;
      if (isDelete) {
        // for delete method ,don't need to check with data
        state[stateKey] = action.payload;
      } else {
        state[stateKey] = action.payload ?? [];
      }
    })
    .addCase(thunk.rejected, (state) => {
      state[`${stateKey}Loading`] = false;
      if (isDelete) {
        state.errorDelete = "Something went wrong";
      } else {
        state[stateKey] = [];
      }
    });
};

// ---- Slice ----
export const CISOSBOMSlice = createSlice({
  name: "CISOSBOMSlice",
  initialState,
  reducers: {
    resetCISOSBOMData: () => initialState,
  },
  extraReducers: (builder) => {
    // POST
    addApiCases(
      builder,
      RequestsByApplicationSBOMAPI,
      "RequestsByApplicationSBOMData"
    );
    addApiCases(builder, RequestStatusCISOSBOMAPI, "RequestStatusCISOSBOMData");
    addApiCases(builder, VulActionPlanCISOSBOMAPI, "VulActionPlanCISOSBOMData");
    addApiCases(builder, CISOsbomTableListAPI, "CISOSBOMTableData");
    addApiCases(builder, ApproveAPI, "CISOSBOMapproveData");
  },
});

export const { resetCISOSBOMData } = CISOSBOMSlice.actions;
export default CISOSBOMSlice.reducer;

// -------- GET --------

// export const DropdownPolicyList = createDynamicThunk(
//   "get/DropdownPolicyList",
//   "/api/v1/riskAssessmentTopic/getAllTopicsAndSubTopics",
//   ["PolicyId"],
//   "GET"
// );

// -------- DELETE --------

// export const PolicyInfodelete = createDynamicThunk(
//   "delete/PolicyInfodelete",
//   "/api/v1/riskAssessmentPolicy/getRiskAssessmentPolicyForDelete",
//   ["policyId", "userName"],
//   "DELETE"
// );
